import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import moment from 'moment-timezone';
import { Tag } from '../../../../models/entities/tag';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { ScrollService } from '../../../../services/scroll.service';
import { JwtLegFiClaims } from '../../../../services/auth/jwt-legfi-claims.model';
import { TagsService } from '../../../../services/tags/tags.service';
import { LegFiJwtService } from '../../../../services/auth/legfi-jwt.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'lf-bulk-tagger',
    templateUrl: './bulk-tagger.component.html',
    styleUrls: ['./bulk-tagger.component.scss'],
})
export class BulkTaggerComponent implements OnInit, OnChanges
{
    // Component State
    uploading: boolean = false;
    loading: boolean = true;
    moment = moment;

    // Models selected for tagging.
    @Input()
    modelIds: any[] = [];
    @Input()
    modelType: string = '';

    // Tags
    tags: Tag[] = [];
    tagTypeColors: { [key: string]: string } = {};
    ifTagsAreFiltering = false;

    private _jwt: JwtLegFiClaims;

    constructor(
            private _activatedRoute: ActivatedRoute,
            private _fb: FormBuilder,
            private _router: Router,
            private _scrollService: ScrollService,
            private _tagsService: TagsService,
    ) {
        this._jwt = LegFiJwtService.read();
    }

    ngOnInit() {
        this.getTags();
    }

    ngOnChanges(changes: SimpleChanges) {
        let refreshTagsList: boolean = false;

        if (changes) {
            if (changes.modelType || changes.modelIds) {
                this.tags = [];
                if (this.modelIds && this.modelIds.length > 0) {
                    refreshTagsList = true;
                }
            }
        }

        if (refreshTagsList) {
            this.getTags();
        }
    }

    public getTags() {
        const jwt = LegFiJwtService.read();
        let request;
        switch (this.modelType) {
            case 'member':
            case 'unit':
            case 'owner':
                request = this._tagsService.getOrganizationTags(
                        jwt.orgId,
                        this.modelType,
                        this.modelIds,
                );
                break;
        }

        if (request) {
            this.loading = true;
            request.pipe(untilDestroyed(this)).subscribe(
                    (tags: Tag[]) => {
                        this.tags = tags;
                        this.loading = false;

                        this.tagTypeColors = this._tagsService.allocateTagColors(this.tags);
                        this.ifTagsAreFiltering = this.tags && this.tags.length > 0;
                    },
                    () => {
                        this.loading = false;
                    },
            );
        }
    }

    /**
     * Create Tag
     * @param {Tag} tag
     */
    public onAddTag(tag: Tag) {
        const request = {
            organizationId: this._jwt.orgId,
            modelIds: this.modelIds,
            ...tag,
        };
        this._tagsService
                .createModelTags(this.modelType, request)
                .subscribe(() => {
                });

        const tags = this.tags.map(t => t.tag);
        this.ifTagsAreFiltering = tags && tags.length > 0;
    }

    /**
     * @param {Tag} tag
     */
    public onRemoveTag(tag: Tag) {
        this._tagsService
                .deleteModelTags(tag.tag, this.modelType, this.modelIds)
                .subscribe(() => {
                });

        const tags = this.tags.map(t => t.tag);
        this.ifTagsAreFiltering = tags && tags.length > 0;
    }
}
